import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface exitSlipModalState {
  value: ExitSlipModal;
}

interface ExitSlipModal {
  visible: boolean;
  type?: ExitSlipModalType;
  exitSlipKey?: number;
}

export enum ExitSlipModalType {
  ASSIGN = 'ASSIGN',
  EDIT = 'EDIT',
}
const initialState: exitSlipModalState = { value: { visible: false, type: ExitSlipModalType.ASSIGN, exitSlipKey: 0 } };

export const exitSlipModalSlice = createSlice({
  name: 'exitSlipModal',
  initialState,
  reducers: {
    setExitSlipModal: (state: exitSlipModalState, action: PayloadAction<ExitSlipModal>) => {
      state.value = action.payload;
    },
  },
});

export const selectedExitSlipModal = (state: RootState) => state.exitSlipModal.value;

export const { setExitSlipModal } = exitSlipModalSlice.actions;

export default exitSlipModalSlice.reducer;
